// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"89":"40ce4e5a","341":"b759af1d","595":"67d07ca4","814":"d6bdec06"}[chunkId] + ".chunk.js";
};